<template>
  <div id="imnar"></div>
  <div id="innerpage">
    <nav>
      <router-link to="/" @mouseover="scramble">About</router-link>
      <router-link to="software" @mouseover="scramble">Software</router-link>
      <router-link to="hardware" @mouseover="scramble">Hardware</router-link>
      <router-link to="audio" @mouseover="scramble">Audio</router-link>
      <router-link to="video" @mouseover="scramble">Video</router-link>
      <router-link to="gamedev" @mouseover="scramble">GameDev</router-link>
      <router-link to="conventions" @mouseover="scramble">Conventions</router-link>
    </nav>
    <main>

      <router-view v-slot="{ Component }">
        <Transition name="swipe">
          <component :is="Component" />
        </Transition>
      </router-view>

      
    </main>
    <Footer/>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');

body{
  padding: 0;
  margin: 0;
  background-color: rgb(15, 15, 15);
  color: #e6e6e6;
  font-family: "Ubuntu Mono", monospace;
  font-weight: 400;
  font-style: normal;
  scroll-behavior: smooth;
  overflow-x: hidden;
  overflow: hidden;
}

.ns {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

nav{
  width: 100%;
  background-color: #FFFFFF;
  color:rgb(22, 22, 22);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 1.1em;
}

nav>a:visited{
  color: inherit;
}

nav>a:hover{
  background-color: rgb(194, 194, 194);
}
nav>a.router-link-active:hover{
  background-color: rgb(78, 78, 78);
}

nav>a.router-link-active{
  background-color: rgb(49, 49, 49);
  color: #FFFFFF;
}

nav>a{
  color: inherit;
  text-decoration: none;
  background-color: transparent;
  padding: 1em;
  border-right-width: 0.1em;
  border-right-style: solid;
  border-image: 
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.418), 
      rgba(0, 0, 0, 0)
    ) 1 100%;
}

nav>a:last-child{
  border: none;
}

#innerpage{
  opacity: 0;
}

.fly{
  animation-name: fly;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-duration: 2s;
  animation-delay: 300ms;
  animation-timing-function: cubic-bezier(1,-0.13,.56,.99);
}
#imnar{
  position: absolute;
  z-index: 100;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

#imnar canvas{
  width: 100% !important;
  height: 100% !important;
}

@keyframes fly {
  0%{
    transform: scale(.4) translate(0,-40%);
    opacity: 0;
  }
  100%{
    transform: scale(1)translate(0,0);
    opacity: 1;
  }
}

.swipe-enter-active{
  transition: all 0.3s ease-in-out;
}
.swipe-leave-active {
  transition: all 0.3s ease-in-out;
}

.swipe-enter-from {
  opacity: 0;
  transform: translate(-10%, 0%);
}
.swipe-leave-to {
  opacity: 0;
  transform: translate(-10%, 0%);
}

</style>

<script>
import * as THREE from 'three';
import {
  GLTFLoader
} from 'three/addons/loaders/GLTFLoader.js';

import Footer from '@/components/Footer.vue';
import {Howl, Howler} from 'howler';
import { useConfigStore } from "@/stores/config";
import { computed, ref } from 'vue'
// await new Promise(r => setTimeout(r, 2000));
export default {
  props: [],
  components: {
    Footer
  },
  setup(props, ctx) {
    const anim = ref(true);
    window.THREE = THREE
    const us = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890+`*!@#$%^&*()[]{}".split("")
    const ls = "abcdefghijklmnopqrstuvwxyz.,".split("")
    const scramble = async (e) => {
      if (!e.target.attributes.getNamedItem("scramble")) {
        e.target.setAttribute("scramble", true)
        const txt = e.target.innerText
        let rp = -1;
        let lp = -4;
        (async function () {
          while (lp < txt.length || rp < txt.length) {
            let pre = txt.substring(0, lp)
            let scr = txt.substring(lp, rp).split("").map(c => {
              let v = ""
              switch (true) {
                case c == " " || c == "-" || c == "_":
                  return [" ", "-", "_", "=", "~"][Math.floor(Math.random() * 5)]

                case c.charCodeAt(0) > 0x40 && c.charCodeAt(0) <= 0x5A:
                  return us[Math.floor(Math.random() * us.length)]

                case c.charCodeAt(0) > 0x60 && c.charCodeAt(0) <= 0x7A:
                  return ls[Math.floor(Math.random() * ls.length)]

                default:
                  return String.fromCharCode(Math.floor(Math.random() * 94) + 33)
              }
            }).join("")
            let post = txt.substring(rp, txt.length)
            e.target.innerText = pre + scr + post
            await new Promise(r => setTimeout(r, 45));
          }
          e.target.innerText = txt
          e.target.removeAttribute("scramble")
        })()

        for (let i = 0; i < txt.length + 5; i++) {
          lp++;
          rp++;
          await new Promise(r => setTimeout(r, 50));
        }


      }

    }

    
    const conf_store = useConfigStore()
    return {
      scramble,
      anim,
      conf_store
    }
  },
  mounted(ctx){
    const cf_ref = this.conf_store
    if(!cf_ref.imnar){
      document.body.style.overflowY = 'auto';
      document.getElementById('innerpage').style.opacity = 1;
      document.getElementById('imnar').remove()
      return
    }
    const tap_sound = new Howl({
      src: [require('@/assets/audio/tap.ogg')]
    });
    const scene = new THREE.Scene();
    const CLOCK = new THREE.Clock(true);
    CLOCK.getDelta()
    var camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

    const domel = document.getElementById('imnar')
    const renderer = new THREE.WebGLRenderer({logarithmicDepthBuffer: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize( domel.scrollWidth, domel.scrollHeight );
    renderer.setClearColor( 0xffffff, 0);
    domel.appendChild(renderer.domElement);
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();
    let mixer;
    let clips;

    camera.position.z = 5;

    // Instantiate a loader
    const loader = new GLTFLoader();
    const x = require('@/assets/models/imnar.glb');
    // Load a glTF resource
    loader.load(
      // resource URL
      x.default,
      // called when the resource is loaded
      function (gltf) {

        scene.add(gltf.scene);

        gltf.animations; // Array<THREE.AnimationClip>
        gltf.scene; // THREE.Group
        gltf.scenes; // Array<THREE.Group>
        gltf.cameras; // Array<THREE.Camera>
        gltf.asset; // Object
        camera = gltf.cameras[0]
        camera.aspect = domel.clientWidth / domel.clientHeight;
        camera.updateProjectionMatrix();
        // camera.position.z = 20;
        // Create an AnimationMixer, and get the list of AnimationClip instances
        mixer = new THREE.AnimationMixer( gltf.scene );
        clips = gltf.animations;

        gltf.scene.getObjectByName('Point').intensity=1;
        gltf.scene.getObjectByName('Point001').intensity=1;
        document.getElementById('innerpage').style.opacity=1;
      },
      // called while loading is progressing
      function (xhr) {

      },
      // called when loading has errors
      function (error) {
        document.getElementById('innerpage').style.opacity=1;
        document.body.style.overflowY = 'auto';
        console.log('An error happened');
        console.log(error)
      }
    );


    function imnar_entry() {
      cf_ref.hideImnar()
      tap_sound.play()
      document.getElementById('innerpage').classList.add('fly')
      clips.forEach( function ( clip ) {
        	let a = mixer.clipAction( clip )
          a.setLoop(THREE.LoopOnce);
          a.clampWhenFinished = true;
          a.play();
        } );
      domel.style.pointerEvents = 'none'
      setTimeout(() => {
        document.body.style.overflowY = 'auto';
      }, 1500);
      
      domel.removeEventListener('mousemove', mousehover)
    }

    function mousehover(event) {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);

      var intersects = raycaster.intersectObject(scene, true);

      if (intersects.length > 0) {
      
	    	var object = intersects[0].object;
        if(object.name === 'imnar_box'){
          domel.style.cursor = 'pointer';
        } else {
          domel.style.cursor = 'default';
        }
      
      }
    }

    domel.addEventListener('click', imnar_entry)
    domel.addEventListener('mousemove', mousehover)

    function animate(ctx) {
      if(!ctx.anim){
        return
      }
      requestAnimationFrame(()=>{
        animate(ctx)
      });
      const dt = CLOCK.getDelta();
      const canvas = renderer.domElement;
      const pixelRatio = window.devicePixelRatio;
      const width  = Math.floor( canvas.clientWidth  * pixelRatio );
      const height = Math.floor( canvas.clientHeight * pixelRatio );
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
        // composer.setSize(width, height, false);
        camera.aspect = domel.clientWidth / domel.clientHeight;
        // camera.position.x = laginter(domel.clientWidth, inter_points_ww);
        camera.updateProjectionMatrix();
      }

      renderer.render(scene, camera);
      if(mixer){
        mixer.update( dt )
      }
    }

    animate(this);
  },
  unmounted(){
    this.anim = false;
  }
}
</script>